import React, { createContext, useContext } from "react";

/**
 * Context to suppress individual widget edit controls.
 * When a parent widget (e.g. ConciergePanelWidget) provides this as true,
 * child WidgetWrappers will skip rendering their own edit UI (pencil icon, panel).
 */
const WidgetEditSuppressContext = createContext<boolean>(false);

export const WidgetEditSuppressProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <WidgetEditSuppressContext.Provider value={true}>
    {children}
  </WidgetEditSuppressContext.Provider>
);

/**
 * Re-enables widget edit controls for a subtree that was previously suppressed.
 * Useful for portaled content (e.g. dialogs) that escapes the parent widget's
 * DOM tree but still inherits the React context.
 */
export const WidgetEditUnsuppressProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <WidgetEditSuppressContext.Provider value={false}>
    {children}
  </WidgetEditSuppressContext.Provider>
);

export const useWidgetEditSuppressed = (): boolean =>
  useContext(WidgetEditSuppressContext);
